<template>
    <div class="baseTransparentMaskMain" @click.self="consoleInfo('main click')" />
</template>

<script>

export default {
    name: "BaseTransparentMask",

    methods: {
        removeDialog() {
            this.remove();
        },
    },
}
</script>

<style lang="scss" scoped>
//
.baseTransparentMaskMain {
    z-index: 1990;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    background-color: rgba(0, 0, 0, 0);;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

</style>